/**
 * Decodes the `bh_claims.products[0].status` entitlement status from a
 * Supabase access token, so callers know whether activate/confirm is still needed.
 */
export const getEntitlementStatus = (accessToken: string): string | undefined => {
  try {
    const base64Url = accessToken.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const payload = JSON.parse(atob(padded));
    return payload.bh_claims?.products?.[0]?.status;
  } catch {
    return undefined;
  }
};
